/*
    🔥 EJE TIPOGRAFÍA

    Cuarto eje, independiente de los otros tres:
      LEVEL__LAYOUT_STYLE_TEMPLATE -> forma   (radios, bordes)
      data-theme                   -> color   (claro / oscuro)
      LEVEL__HEADER_*_TEMPLATE     -> disposición
      LEVEL__FONT_TEMPLATE         -> tipografía  ← este

    Cada opción define DOS familias: cuerpo y títulos. Separarlas es lo
    que permite combinaciones editoriales (serif en títulos, sans en texto).

    google: null -> fuente del sistema, no descarga nada.
            url  -> se inyecta el <link> la primera vez que se elige.
                    Nunca se cargan las 11 juntas.
*/

const SYSTEM_SANS = 'system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';
const SYSTEM_MONO = 'ui-monospace, SFMono-Regular, Menlo, Consolas, "Liberation Mono", monospace';

export const FONT_TEMPLATES = [

    {
        id: 'system', label: 'Sistema', google: null,
        base: SYSTEM_SANS, title: SYSTEM_SANS,
    },

    {
        id: 'inter', label: 'Inter', base: '"Inter", ' + SYSTEM_SANS, title: '"Inter", ' + SYSTEM_SANS,
        google: 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap',
    },

    {
        id: 'poppins', label: 'Poppins', base: '"Poppins", ' + SYSTEM_SANS, title: '"Poppins", ' + SYSTEM_SANS,
        google: 'https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap',
    },

    {
        id: 'montserrat', label: 'Montserrat', base: '"Montserrat", ' + SYSTEM_SANS, title: '"Montserrat", ' + SYSTEM_SANS,
        google: 'https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&display=swap',
    },

    {
        id: 'roboto', label: 'Roboto', base: '"Roboto", ' + SYSTEM_SANS, title: '"Roboto", ' + SYSTEM_SANS,
        google: 'https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700;900&display=swap',
    },

    {
        id: 'nunito', label: 'Nunito', base: '"Nunito Sans", ' + SYSTEM_SANS, title: '"Nunito", ' + SYSTEM_SANS,
        google: 'https://fonts.googleapis.com/css2?family=Nunito:wght@600;700;800&family=Nunito+Sans:wght@400;500;600&display=swap',
    },

    {
        id: 'raleway', label: 'Raleway', base: '"Raleway", ' + SYSTEM_SANS, title: '"Raleway", ' + SYSTEM_SANS,
        google: 'https://fonts.googleapis.com/css2?family=Raleway:wght@400;500;600;700;800&display=swap',
    },

    {
        id: 'editorial', label: 'Editorial (Playfair + Source Sans)',
        base: '"Source Sans 3", ' + SYSTEM_SANS, title: '"Playfair Display", Georgia, serif',
        google: 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700;800&family=Source+Sans+3:wght@400;500;600&display=swap',
    },

    {
        id: 'lora', label: 'Lora (serif)', base: '"Lora", Georgia, serif', title: '"Lora", Georgia, serif',
        google: 'https://fonts.googleapis.com/css2?family=Lora:wght@400;500;600;700&display=swap',
    },

    {
        id: 'mono', label: 'Monoespaciada', google: null,
        base: SYSTEM_MONO, title: SYSTEM_MONO,
    },

    {
        id: 'georgia', label: 'Georgia (sistema)', google: null,
        base: 'Georgia, "Times New Roman", serif', title: 'Georgia, "Times New Roman", serif',
    },

];

export const FONT_TEMPLATE_IDS = FONT_TEMPLATES.map((item) => item.id);

const FALLBACK_TEMPLATE = FONT_TEMPLATES[0];

export const onResolveFontTemplate = (id) => (
    FONT_TEMPLATES.find((item) => item.id === id) ?? FALLBACK_TEMPLATE
);

/*
    🔥 CARGA BAJO DEMANDA

    Inyecta el <link> de Google Fonts solo cuando esa opción se usa,
    y una sola vez por fuente. Sin esto habría que cargar las once
    en el index.html y castigar el arranque.
*/
export const onLoadFontTemplate = (template) => {

    if (!template?.google) return;

    const ID = `LStudio__font_${template.id}`;

    if (document.getElementById(ID)) return;

    const LINK = document.createElement('link');
    LINK.id = ID;
    LINK.rel = 'stylesheet';
    LINK.href = template.google;

    document.head.appendChild(LINK);
};
